export class PaymentType {
    _id: string;
    name: string;
    fixed: boolean =false;
    amount: number;
    createdDate: Date;
}